import { FC } from 'react'
import { IconProps, icons } from './svg-icon.utils'

const SVGIcon: FC<IconProps> = ({
  onClick,
  icon,
  width,
  height,
  className,
  stroke,
  strokeWidth,
}) => {
  const IconComponent = icons[icon]

  return IconComponent ? (
    <span
      onClick={onClick}
      role="img"
      aria-label={icon}
      className={`inline-flex items-center justify-center ${className}`} // ✅ Dynamic color
    >
      {IconComponent({ width, height, stroke: 'currentColor', strokeWidth })}
      {/* ✅ CurrentColor */}
    </span>
  ) : null
}

export default SVGIcon
